import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import { getMarketplace } from '../../services/MarketplaceService';
import { getMetadata } from '../../services/MetadataService';
import { isLargeScreen } from "../../utilities/ScreenView";
import Trange from './Trange'

const Marketplace = () => {

    const marketplacenames = [
          { label: "US 30"         , value: "USA30IDXUSD" }   // 0
        , { label: "USA 500"       , value: "USA500IDXUSD" }  // 1
        , { label: "NASDAQ 100"    , value: "USATECHIDXUSD" } // 2
        , { label: "Europe 50"     , value: "EUSIDXEUR" }     // 3
        , { label: "DAX 30"        , value: "DEUIDXEUR" }     // 4
        , { label: "UK 100"        , value: "GBRIDXGBP" }     // 5
        , { label: "HK 40"         , value: "HKGIDXHKD" }     // 6
        , { label: "Australia 200" , value: "AUSIDXAUD" }     // 7
        , { label: "Japan 225"     , value: "JPNIDXJPY" }     // 8
        , { label: "Crude Oil"     , value: "BRENTCMDUSD" }   // 9
        , { label: "Gold Comex"    , value: "XAUUSD" }        // 10
        , { label: "Silver Comex"  , value: "XAGUSD" }        // 11
        , { label: "AUDCAD"        , value: "AUDCAD" }        // 12
        , { label: "AUDUSD"        , value: "AUDUSD" }        // 13
        , { label: "BTCUSD"        , value: "BTCUSD" }        // 14
        , { label: "EURAUD"        , value: "EURAUD" }        // 15
        , { label: "EURGBP"        , value: "EURGBP" }        // 16
        , { label: "EURUSD"        , value: "EURUSD" }        // 17
        , { label: "GBPCHF"        , value: "GBPCHF" }        // 18
        , { label: "GBPUSD"        , value: "GBPUSD" }        // 19
        , { label: "NZDUSD"        , value: "NZDUSD" }        // 20
        , { label: "USDCAD"        , value: "USDCAD" }        // 21
        , { label: "USDCHF"        , value: "USDCHF" }        // 22
        , { label: "USDJPY"        , value: "USDJPY" }        // 23
    ]

    const [marketplaces, setMarketplaces] = useState([])
    const [marketplacessaved, setMarketplacessaved] = useState([])
    const [value, setValue] = useState('')
    var { name } = useParams();
    name = "open.market"

    useEffect(() => {
        // const interval = setInterval(() => { listMarketplace(); listAllTickers(); setDate(new Date()); }, 10000)
        const interval = setInterval(() => { listMarketplace(); listMetadata(); }, 2000)
        return () => {  clearInterval(interval); }
    });

    function listMetadata() {
        getMetadata(name).then((response) => {
            setValue(response.data.value)
        }).catch(error => {
            console.log(error);
        })
    }

    function listMarketplace() {
        getMarketplace().then((response) => {
            setMarketplacessaved(response.data);
        }).catch((error) => { console.log(error); })
        if (marketplacessaved.length === 24) { setMarketplaces(marketplacessaved); }
    }

    function getMarketplaceName(idx) {
        return marketplacenames[idx].label;
    }

    function showMarketPercent(idx) {
        if (marketplaces[idx] !== undefined) {
            // const percent = ((marketplaces[idx].close - marketplaces[idx].open) / marketplaces[idx].open * 100).toFixed(2);  && marketplaces[idx].close > 0 && marketplaces[idx].indicator === marketplacenames[idx].value
            const percent = marketplaces[idx].percent.toFixed(2);
            if (percent !== undefined) {
                if (percent.includes("-")) return <td style={{ fontSize: 'small' }} className="col col-lg-1 text-danger">{percent}%</td>
                if (percent === '0.00') return <td style={{ fontSize: 'small' }} className="col col-lg-1 text-secondary">&nbsp;{percent}%</td>
                return <td style={{ fontSize: 'small' }} className="col col-lg-1 text-success">&nbsp;{percent}%</td>
            }
        }
        return <div style={{ fontSize: 'small' }} className="col col-lg-1 text-success">&nbsp;</div>
    }

    function getOpenMarketTimestamp(idx) {
        if (marketplaces[idx] !== undefined)
        return <td style={{ fontSize: 'small' }} className="col col-lg-1">{new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'short',day: '2-digit', hour: '2-digit', minute: '2-digit'}).format(marketplaces[idx].openMarketTimestamp)}</td>
    }

    function showOpenMarket() {
        return (
            <>
                <span className="sp-ot">Open Market</span>
                { isLargeScreen() ? 
                    <table className="border border-light border-1 table-sm">
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(0)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(0)}</td>
                            <td>&nbsp;&nbsp;</td>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(1)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(1)}</td>
                        </tr>                           
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(2)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(2)}</td>
                            <td>&nbsp;&nbsp;</td>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(3)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(3)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(4)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(4)}</td>
                            <td>&nbsp;&nbsp;</td>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(5)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(5)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(6)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(6)}</td>
                            <td>&nbsp;&nbsp;</td>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(7)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(7)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(8)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(8)}</td>
                            <td>&nbsp;&nbsp;</td>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(9)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(9)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(10)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(10)}</td>
                            <td>&nbsp;&nbsp;</td>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(11)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(11)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(12)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(12)}</td>
                            <td>&nbsp;&nbsp;</td>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(13)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(13)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(14)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(14)}</td>
                            <td>&nbsp;&nbsp;</td>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(15)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(15)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(16)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(16)}</td>
                            <td>&nbsp;&nbsp;</td>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(17)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(17)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(18)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(18)}</td>
                            <td>&nbsp;&nbsp;</td>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(19)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(19)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(20)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(20)}</td>
                            <td>&nbsp;&nbsp;</td>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(21)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(21)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(22)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(22)}</td>
                            <td>&nbsp;&nbsp;</td>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(23)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(23)}</td>
                        </tr>
                    </table>
                : 
                    <table className="border border-light border-1 table-sm">
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(0)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(0)}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(1)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(1)}</td>
                        </tr>                           
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(2)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(2)}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(3)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(3)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(4)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(4)}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(5)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(5)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(6)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(6)}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(7)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(7)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(8)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(8)}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(9)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(9)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(10)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(10)}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(11)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(11)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(12)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(12)}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(13)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(13)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(14)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(14)}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(15)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(15)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(16)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(16)}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(17)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(17)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(18)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(18)}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(19)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(19)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(20)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(20)}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(21)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(21)}</td>
                        </tr>
                        <tr style={{ backgroundColor: '#f7f7f7'}}>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(22)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(22)}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: 'small', color: '#006666' }} className="fw-normal">{getMarketplaceName(23)}</td>
                            <td style={{ fontSize: 'small', color: '#888888' }} className="fw-normal">{getOpenMarketTimestamp(23)}</td>
                        </tr>
                    </table>
                }
            </>
        )
    }

    function showMarketplace() {
        return (
            <>
                <div style={{paddingLeft: '60px' }} className="col-sm-8">
                    <div className="row-1">
                        <span className="sp-ot">Marketplace</span>
                        <table className="border border-light border-1 table-sm">
                            <tbody>
                                <tr style={{ backgroundColor: '#f7f7f7'}}>
                                    <td style={{ fontSize: 'small', color: '#006666' }}>{getMarketplaceName(0)}</td>
                                    {showMarketPercent(0)}
                                    <td style={{ fontSize: 'small', color: '#006666' }}>{getMarketplaceName(1)}</td>
                                    {showMarketPercent(1)}
                                    <td style={{ fontSize: 'small', color: '#006666' }}>{getMarketplaceName(2)}</td>
                                    {showMarketPercent(2)}
                                </tr>

                                <tr style={{ backgroundColor: '#f7f7f7'}}>
                                    <td style={{ fontSize: 'small', color: '#006666' }}>{getMarketplaceName(3)}</td>
                                    {showMarketPercent(3)}
                                    <td style={{ fontSize: 'small', color: '#006666' }}>{getMarketplaceName(4)}</td>
                                    {showMarketPercent(4)}
                                    <td style={{ fontSize: 'small', color: '#006666' }}>{getMarketplaceName(5)}</td>
                                    {showMarketPercent(5)}
                                </tr>

                                <tr style={{ backgroundColor: '#f7f7f7'}}>
                                    <td style={{ fontSize: 'small', color: '#006666' }}>{getMarketplaceName(6)}</td>
                                    {showMarketPercent(6)}
                                    <td style={{ fontSize: 'small', color: '#006666' }}>{getMarketplaceName(7)}</td>
                                    {showMarketPercent(7)}
                                    <td style={{ fontSize: 'small', color: '#006666' }}>{getMarketplaceName(8)}</td>
                                    {showMarketPercent(8)}
                                </tr>

                                <tr style={{ backgroundColor: '#fcf5de'}}>
                                    <td style={{ fontSize: 'small', color: 'grey' }}>{getMarketplaceName(9)}</td>
                                    {showMarketPercent(9)}
                                    <td style={{ fontSize: 'small', color: 'grey' }}>{getMarketplaceName(10)}</td>
                                    {showMarketPercent(10)}
                                    <td style={{ fontSize: 'small', color: 'grey' }}>{getMarketplaceName(11)}</td>
                                    {showMarketPercent(11)}
                                </tr>

                                <tr style={{ backgroundColor: '#dff3f4'}}>
                                    <td style={{ fontSize: 'small', color: '#0000cc' }}>{getMarketplaceName(12)}</td>
                                    {showMarketPercent(12)}
                                    <td style={{ fontSize: 'small', color: '#0000cc' }}>{getMarketplaceName(13)}</td>
                                    {showMarketPercent(13)}
                                    <td style={{ fontSize: 'small', color: '#0000cc' }}>{getMarketplaceName(14)}</td>
                                    {showMarketPercent(14)}
                                </tr>

                                <tr style={{ backgroundColor: '#dff3f4'}}>
                                    <td style={{ fontSize: 'small', color: '#0000cc' }}>{getMarketplaceName(15)}</td>
                                    {showMarketPercent(15)}
                                    <td style={{ fontSize: 'small', color: '#0000cc' }}>{getMarketplaceName(16)}</td>
                                    {showMarketPercent(16)}
                                    <td style={{ fontSize: 'small', color: '#0000cc' }}>{getMarketplaceName(17)}</td>
                                    {showMarketPercent(17)}
                                </tr>

                                <tr style={{ backgroundColor: '#dff3f4'}}>
                                    <td style={{ fontSize: 'small', color: '#0000cc' }}>{getMarketplaceName(18)}</td>
                                    {showMarketPercent(18)}
                                    <td style={{ fontSize: 'small', color: '#0000cc' }}>{getMarketplaceName(19)}</td>
                                    {showMarketPercent(19)}
                                    <td style={{ fontSize: 'small', color: '#0000cc' }}>{getMarketplaceName(20)}</td>
                                    {showMarketPercent(20)}
                                </tr>
                                
                                <tr style={{ backgroundColor: '#dff3f4'}}>
                                    <td style={{ fontSize: 'small', color: '#0000cc' }}>{getMarketplaceName(21)}</td>
                                    {showMarketPercent(21)}
                                    <td style={{ fontSize: 'small', color: '#0000cc' }}>{getMarketplaceName(22)}</td>
                                    {showMarketPercent(22)}
                                    <td style={{ fontSize: 'small', color: '#0000cc' }}>{getMarketplaceName(23)}</td>
                                    {showMarketPercent(23)}
                                </tr>
                            </tbody>
                        </table>
                        { value === "true" ? showOpenMarket() : "" }
                    </div>
                    <div className="row-1">
                        <Trange />
                    </div>
                </div>
            </>
        )
    }

    function showSpinner() {
        return (
            <>
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </>
        )
    }

    return (
        <>
            { marketplaces.length > 0 ? showMarketplace() :  showSpinner() }
        </>
    )
}

export default Marketplace